import React from 'react';

/**
 * TemplatePicker — visual grid of available SocialTheme templates.
 *
 * Props:
 *  - themes        : array of SocialTheme objects
 *  - onApplyTheme  : (themeId) => void — applies theme to all slides
 *  - currentThemeId : string — currently applied theme (for highlight)
 */
export default function TemplatePicker({ themes = [], onApplyTheme, currentThemeId }) {
  if (!themes.length) {
    return (
      <div className="tw-text-xs tw-text-zinc-500 tw-text-center tw-py-4">
        No templates available. Create them in Admin → Social Posts → Themes.
      </div>
    );
  }

  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-3">
      {themes.map((theme) => {
        const isActive = currentThemeId === theme._id;
        const gradient =
          theme.gradientColors?.length >= 2
            ? `linear-gradient(${theme.gradientDirection || 'to bottom'}, ${theme.gradientColors[0]}, ${theme.gradientColors[1]})`
            : theme.gradientColors?.[0] || '#333';

        return (
          <button
            key={theme._id}
            onClick={() => onApplyTheme(theme._id)}
            className={`tw-rounded-xl tw-border tw-p-3 tw-transition-all tw-text-left ${
              isActive
                ? 'tw-border-social-pink tw-bg-social-pink/5 tw-ring-1 tw-ring-social-pink/30'
                : 'tw-border-zinc-700 tw-bg-zinc-900 hover:tw-border-zinc-500'
            }`}
          >
            {/* Preview swatch */}
            <div className="tw-h-16 tw-rounded-lg tw-mb-2 tw-overflow-hidden tw-relative" style={{ background: gradient }}>
              <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
                <span
                  className="tw-text-sm tw-font-black tw-uppercase"
                  style={{ color: theme.textColor || '#fff', fontFamily: theme.fontFamily || 'inherit' }}
                >
                  Aa
                </span>
              </div>
              {theme.templateBackgrounds?.[0] && (
                <img
                  src={theme.templateBackgrounds[0]}
                  alt=""
                  className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-opacity-40"
                />
              )}
            </div>
            <div className="tw-text-[10px] tw-font-bold tw-text-zinc-400 tw-uppercase tw-tracking-wider tw-truncate">
              {theme.name}
            </div>
            {theme.layoutPreset && (
              <div className="tw-text-[9px] tw-text-zinc-600 tw-mt-0.5 tw-capitalize">
                {theme.layoutPreset}
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}
